import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

let authLockQueue = Promise.resolve();

const localAuthLock = async (_name, _timeout, callback) => {
  const previous = authLockQueue;
  let releaseLock;

  authLockQueue = new Promise((resolve) => {
    releaseLock = resolve;
  });

  await previous;

  try {
    return await callback();
  } finally {
    releaseLock();
  }
};

export const supabase = isSupabaseConfigured
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        lock: localAuthLock,
      },
    })
  : null;
